module.exports = __webpack_public_path__ + "static/media/titlecard_faveinsights@2x.afcf4956.jpg";